module.exports = __webpack_public_path__ + "static/media/xpm.0a6ba582.svg";